// export const config = { Umfrage_URL: 'http://localhost:45599/', Host: 'http://localhost:3000/' }

export const config = { Umfrage_URL: 'https://servicestest.gfa-cert.com/', Host: 'https://req.gfa-cert.com/' }